import { AzureEnvironment, idNameItem } from 'jk-service';

export const companyList: idNameItem[] = [
  {
    id: 'JACK168-95',
    name: '傑克',
    icon: './assets/images/jack_logo.png',
    ps1: 'https://www.jack168.com:8098',
    ps2: 'JACKIE,KM_SYS,JACK',
    ps3: '',
  },
  {
    id: 'JACK168-95TEST',
    name: '傑克-測試',
    icon: './assets/images/jack_logo.png',
    ps1: 'http://rd-u24.local:9098',
    ps2: 'JACKIE,KM_SYS,JACK',
    ps3: '',
  },
];

export const environment = {
  production: false,
  appName: 'jksupport',
  title: '傑克支援系統',
  appDescript: '傑克支援系統',
  appId: 'jk-support',
  version: '20261001-5',
  jwtSecret: 'giant168',
  sysdbname: 'KM_SYS',
  reportUrl: 'https://www.jack168.com/report',
  configFileName: 'jk-support.json',
  firebaseLogin: true,
  openai_upload: '~/openai_upload',
  testUrl: 'https://www.jack168.com:8086',
  fbId: 'FACEBOOK_APP_ID',
  stripePublicKey: 'STRIPE_PUBLIC_KEY',
  expireHour: 36,
  androidHeaderColor: '#5D67D4',
  defaultLang: 'zh-TW',

  GOOGLE_CLIENT_ID:
    '502092863161-u111mcnubjn7t16sr464b6mjblsjspeq.apps.googleusercontent.com',
  GOOGLE_API_KEY: '請由service提供',
  currency: {
    code: 'NTD',
    display: 'symbol',
    digitsInfo: '1.2-2',
  },
  wsUrl: 'ws://jk-ubun:8888',
  emulator: false,
  serverIP: 'localhost',
};

export const azureEnv: AzureEnvironment = {
  tts_key: '',
  tts_url: 'https://eastasia.tts.speech.microsoft.com/cognitiveservices/v1',
  translate_key: '',
  AZURE_OPENAI_KEY: '',
  AZURE_OPENAI_ENDPOINT: '',
  region: 'eastasia',
};
